import React, { useEffect, useState } from "react";
import {
  TextField, Table, TableHead, TableRow, TableCell, TableBody,
  Pagination, Button, Grid
} from "@mui/material";
import axios from "axios";
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";


const API_URL = process.env.REACT_APP_API_URL;

export default function InvoiceList() {
  const [invoices, setInvoices] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchInvoices = async () => {
    const res = await axios.get(`${API_URL}/invoices/`, {
      params: {
        search,
        page,
        start_date: startDate,
        end_date: endDate
      }
    });

    setInvoices(res.data.results || []);
    setTotal(res.data.total || 0);
  };

  useEffect(() => {
    fetchInvoices();
  }, [page]);

  const applyDateFilter = () => {
    setPage(1);
    fetchInvoices();
  };

  return (
    <div>
        <Header1/>
    <div style={{ padding: 20 }}>
      <h2>Invoices</h2>

      {/* Search Box */}
      <TextField
        label="Search by Transaction ID"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyPress={(e) => e.key === "Enter" && fetchInvoices()}
        fullWidth
        style={{ marginBottom: 20 }}
      />

      {/* Date Range Filters */}
      <Grid container spacing={2} style={{ marginBottom: 20 }}>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="End Date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={applyDateFilter}
            style={{ height: "55px" }}
          >
            Apply Filter
          </Button>
        </Grid>
      </Grid>

      {/* Invoice Table */}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Invoice Number</TableCell>
            <TableCell>Transaction ID</TableCell>
            <TableCell>Created</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {invoices.length > 0 ? (
            invoices.map((inv) => (
              <TableRow key={inv.public_id}>
                <TableCell>{inv.invoice_number}</TableCell>
                <TableCell>{inv.transaction_id}</TableCell>
                <TableCell>{inv.created_at}</TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    href={`/invoice-view?transaction_id=${inv.transaction_id}`}
                  >
                    View
                  </Button>
                  &nbsp;
                  <Button
                    variant="contained"
                    href={`${API_URL}/invoices/download/?transaction_id=${inv.transaction_id}`}
                  >
                    Download
                  </Button>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} align="center">
                No invoices found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      {/* Pagination */}
      <Pagination
        count={Math.ceil(total / 10)}
        page={page}
        onChange={(e, val) => setPage(val)}
        style={{ marginTop: 20 }}
      />
    </div>
    <Footer2/>
    </div>
  );
}
